import { DomSanitizer } from '@angular/platform-browser';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { IOrder, NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';

import { RETURN_METHODS } from '../../../return-packaging/models/return-packaging.constants';
import { getReturnPackagingOrderLine } from '../../../return-packaging/policy/return-packaging.policy';

/**Tells the customer what to do with the packaging once the order is placed. Renders nothing unless
 * the order carries a return line, so every receipt can mount it unconditionally.*/
@Component({
  standalone: true,
  selector: 'return-info-partial',
  imports: [TranslateModule, NgCakeItEasyUtilsModule],
  templateUrl: './return-info-partial.component.html',
  styleUrls: ['./return-info-partial.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReturnInfoPartialComponent {
  readonly order = input.required<IOrder>();

  private readonly _sanitizer = inject(DomSanitizer);

  readonly returnLine = computed(() => getReturnPackagingOrderLine(this.order()?.orderLines));

  readonly instructions = computed(() => {
    const line = this.returnLine();
    const settings = this.order()?.bakery?.returnPackagingSettings;

    if (!line || !settings) {
      return null;
    }

    const html = line.returnPackaging.returnMethod === RETURN_METHODS.SELF
      ? settings.returnThemselvesInstructionsEmail
      : settings.returnCourierInstructionsEmail;

    return html ? this._sanitizer.bypassSecurityTrustHtml(html) : null;
  });
}
